/**
 * we are doing a 1-to-1 mapping with Zuora products to add additional information for translations purposes
 * and also to make it easy to find things by sku, plan, prod etc.
 * see [Billing 3.0 products](https://hotjar.atlassian.net/wiki/spaces/MP/pages/2974875706/Billing+3.0+Products)
 */

import type { Plan, PlanName, PlanId, Product, ProductName, ProductId, Sku } from '../api/model';

type SkuDictionary = {
  [sku: Sku]: {
    product: Omit<Product, 'plans'>;
    plan: Omit<Plan, 'allowances'>;
  };
};

export const productDictionary: Record<ProductId, ProductName> = {
  'PROD-1': 'ask',
  'PROD-2': 'observe',
};

export const planDictionary: Record<PlanId, PlanName> = {
  'PLAN-1': 'basic',
  'PLAN-2': 'plus',
  'PLAN-3': 'business',
  'PLAN-4': 'scale',
  'PLAN-5': 'basic',
  'PLAN-6': 'plus',
  'PLAN-7': 'business',
  'PLAN-8': 'scale',
};

export const productToBasicAllowanceSku: Record<ProductId, Sku> = {
  'PROD-1': 'SKU-22',
  'PROD-2': 'SKU-24',
};

/**
 * @deprecated Please use the one in the ProductCatalogRepository
 */
export const allowanceDictionary: SkuDictionary = {
  'SKU-22': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-1', name: planDictionary['PLAN-1'], planTier: 0 },
  },
  'SKU-1': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-2', name: planDictionary['PLAN-2'], planTier: 1 },
  },
  'SKU-2': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-3': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-4': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-5': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-6': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-7': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-8': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-9': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-10': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-3', name: planDictionary['PLAN-3'], planTier: 2 },
  },
  'SKU-23': {
    product: { id: 'PROD-1', name: productDictionary['PROD-1'] },
    plan: { id: 'PLAN-4', name: planDictionary['PLAN-4'], planTier: 3 },
  },
  'SKU-24': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-5', name: planDictionary['PLAN-5'], planTier: 0 },
  },
  'SKU-11': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-6', name: planDictionary['PLAN-6'], planTier: 1 },
  },
  'SKU-12': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-13': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-14': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-15': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-16': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-17': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-18': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-19': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-20': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-21': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-7', name: planDictionary['PLAN-7'], planTier: 2 },
  },
  'SKU-25': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-26': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-27': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-28': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-29': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-30': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-31': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-32': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-33': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-34': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-35': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-36': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-37': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-38': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-39': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-40': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-41': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
  'SKU-42': {
    product: { id: 'PROD-2', name: productDictionary['PROD-2'] },
    plan: { id: 'PLAN-8', name: planDictionary['PLAN-8'], planTier: 3 },
  },
};

export const legacyPlanIdToV3Sku = {
  feedback_basic_20: 'SKU-22',
  feedback_plus_250: 'SKU-1',
  feedback_business_500: 'SKU-2',
  feedback_business_1000: 'SKU-3',
  feedback_business_2500: 'SKU-4',
  feedback_business_5000: 'SKU-5',
  feedback_business_7500: 'SKU-6',
  feedback_business_10000: 'SKU-7',
  feedback_business_25000: 'SKU-8',
  feedback_business_50000: 'SKU-9',
  feedback_business_100000: 'SKU-10',
  feedback_scale: 'SKU-23',

  analytics_basic_2000: 'SKU-24',
  analytics_plus_10000: 'SKU-11',
  analytics_business_20000: 'SKU-12',
  analytics_business_50000: 'SKU-13',
  analytics_business_120000: 'SKU-14',
  analytics_business_200000: 'SKU-15',
  analytics_business_400000: 'SKU-16',
  analytics_business_800000: 'SKU-17',
  analytics_business_2000000: 'SKU-18',
  analytics_business_5000000: 'SKU-19',
  analytics_business_10000000: 'SKU-20',
  analytics_business_15000000: 'SKU-21',
  analytics_scale_40000000: 'SKU-25',
  analytics_scale_500: 'SKU-26',
  analytics_scale_1500: 'SKU-27',
  analytics_scale_2500: 'SKU-28',
  analytics_scale_4000: 'SKU-29',
  analytics_scale_5000: 'SKU-30',
  analytics_scale_8000: 'SKU-31',
  analytics_scale_11000: 'SKU-32',
  analytics_scale_15000: 'SKU-33',
  analytics_scale_25000: 'SKU-34',
  analytics_scale_40000: 'SKU-35',
  analytics_scale_55000: 'SKU-36',
  analytics_scale_70000: 'SKU-37',
  analytics_scale_85000: 'SKU-38',
  analytics_scale_90000: 'SKU-39',
  analytics_scale_180000: 'SKU-40',
  analytics_scale_270000: 'SKU-41',
} as const;
